import React from 'react';
import {
  Button,
  Icon,
  Text,
  VStack,
  useColorModeValue
} from '@chakra-ui/react';
import { FiZap } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

interface ContinueButtonProps {
  onClick: () => void;
  isLoading: boolean;
  isDisabled: boolean;
  selectedWordsCount: number;
}

const ContinueButton: React.FC<ContinueButtonProps> = ({
  onClick,
  isLoading,
  isDisabled,
  selectedWordsCount
}) => {
  const { t } = useTranslation();
  const mutedTextColor = useColorModeValue('gray.600', 'gray.300');

  return (
    <VStack spacing={4}>
      <Button
        size="xl"
        px={12}
        py={6}
        fontSize="lg"
        fontWeight="bold"
        borderRadius="2xl"
        bgGradient="linear(to-r, blue.500, purple.500)"
        color="white"
        rightIcon={<Icon as={FiZap} />}
        onClick={onClick}
        isLoading={isLoading}
        loadingText={t('onboarding.vocabulary.savingVocabulary')}
        isDisabled={isDisabled}
        _hover={{
          bgGradient: "linear(to-r, blue.600, purple.600)",
          transform: "translateY(-2px)",
          shadow: "xl"
        }}
        _active={{
          transform: "translateY(0)",
        }}
        transition="all 0.3s ease"
      >
        {t('onboarding.vocabulary.continue')}
      </Button>

      {selectedWordsCount < 5 && (
        <Text fontSize="sm" color={mutedTextColor} textAlign="center">
          {t('onboarding.vocabulary.chatInstructions', { count: selectedWordsCount })}
        </Text>
      )}
    </VStack>
  );
};

export default ContinueButton;